import { render, staticRenderFns } from "./myfoot.vue?vue&type=template&id=03b19a9e&scoped=true"
import script from "./myfoot.vue?vue&type=script&lang=js"
export * from "./myfoot.vue?vue&type=script&lang=js"
import style0 from "./myfoot.vue?vue&type=style&index=0&id=03b19a9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b19a9e",
  null
  
)

export default component.exports